// Vendor imports
const _ = require('lodash')
// Client lib imports
const airbrake = require('client/lib/airbrake')
const { send: ajax } = require('client/lib/request')
// Client component imports
const Modal = require('client/components/modal')
require('client/components/mix-select-form')

const MIX_SELECT_FORM_SELECTOR = '.mix-select__form'
const RETRY_BUTTON_SELECTOR = '.mix-select-modal__retry-button'
const CONTACT_SUPPORT_BUTTON_SELECTOR = '.mix-select-modal__contact-support-button'

module.exports = class MixSelectModal extends Modal {
  constructor(options) {
    super(_.defaults(options, {
      modalTemplate: require('*views/modals/mix-select'),
      modalClassName: 'base-modal--drawer-right mix-select-modal',
      modalTitle: 'Add to your Collections'
    }))
    _.bindAll(this, ['loadFromArticle', 'showError'])
    this.loadFromOptions()
  }

  loadFromUrl(url) {
    this.options.url = url
    this.showLoading()
    return getArticleForUrl(url)
    .then(this.loadFromArticle)
    .catch(this.showError)
  }

  loadFromArticle(article) {
    this.options.article = article
    this.showLoading()
    return getMixesForUrlId(article['url_id'])
    .then(response => this.update({
      state: 'ready',
      article,
      mixes: response.existing,
      recommended: response.recommended,
      initial: response.initial
    }))
    .catch(this.showError)
  }

  loadFromOptions() {
    const { article, url } = this.options
    // Fetch article details if necessary
    if (article) {
      // Request the mixes for this article
      return this.loadFromArticle(article)
    }
    if (url) {
      // Extract the article details from the URL
      return this.loadFromUrl(url)
    }
    return Promise.resolve()
  }

  showLoading() {
    if (this.options.state !== 'loading') {
      this.update({ state: 'loading' })
    }
  }

  showError(err) {
    if (err.statusCode !== 404) {
      airbrake.notify(err)
    }
    if (this.options.state !== 'error') {
      this.update({ state: 'error' })
    }
  }

  update(newOptions) {
    _.assign(this.options, newOptions)
    if (this.isAttached) {
      this.render()
    }
  }

  didRender() {
    super.didRender()
    // Cache jQuery handles
    this.$form = this.$el.find(MIX_SELECT_FORM_SELECTOR)
    // Register event listeners
    this.$el.on('click', RETRY_BUTTON_SELECTOR, event => {
      event.preventDefault()
      event.stopPropagation()
      this.loadFromOptions()
    })
    this.$el.on('click', CONTACT_SUPPORT_BUTTON_SELECTOR, event => {
      if (typeof window.Intercom === 'function') {
        event.preventDefault()
        window.Intercom('show')
      }
    })
    // Setup child component
    this.$form.MixSelectForm({
      changeCallback: this.options.changeCallback,
      submitCallback: this.dismiss
    })
  }

  detach() {
    if (this.$form) {
      this.$form.MixSelectForm('destroy')
    }
    return super.detach()
  }
}

function getArticleForUrl(url) {
  return ajax({
    url: '/api/v0.1/extract',
    method: 'post',
    data: { url }
  })
  .then(response => {
    const article = _.pick(response, [
      'md5image', 'image', 'hostname',
      'url', 'url_id', 'hash', 'count'
    ])
    return _.assign(article, {
      title: response.title || response.url,
      submittedUrl: response['original_url'],
      timestamp: Date.now()
    })
  })
}

function getMixesForUrlId(urlId) {
  return ajax({
    url: '/api/v0.1/mixes/all',
    method: 'post',
    data: { 'url_id': urlId }
  })
}
